/* ------------------------------------------------ */
/* Zenia Motion System v2                           */
/* Premium animation primitives                     */
/* ------------------------------------------------ */

const ease = [0.22, 1, 0.36, 1]

/* -------------------------------- */
/* Section entrance                 */
/* -------------------------------- */

export const section = {
  hidden: {
    opacity: 0,
    y: 40
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease
    }
  }
}


/* -------------------------------- */
/* Hero animation                   */
/* -------------------------------- */

export const hero = {
  hidden: { opacity: 0, y: 24 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease
    }
  }
}


/* -------------------------------- */
/* Fade up (default)                */
/* -------------------------------- */

export const fadeUp = {
  hidden: {
    opacity: 0,
    y: 18
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease
    }
  }
}


/* -------------------------------- */
/* Simple fade                      */
/* -------------------------------- */

export const fade = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      duration: 0.5,
      ease
    }
  }
}


/* -------------------------------- */
/* Scale in visuals                 */
/* -------------------------------- */

export const scaleIn = {
  hidden: {
    opacity: 0,
    scale: 0.96
  },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.6,
      ease
    }
  }
}


/* -------------------------------- */
/* Slide animations                 */
/* -------------------------------- */

export const slideUp = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.65, ease }
  }
}

export const slideLeft = {
  hidden: { opacity: 0, x: 40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.65, ease }
  }
}

export const slideRight = {
  hidden: { opacity: 0, x: -40 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.65, ease }
  }
}


/* -------------------------------- */
/* Stagger container                */
/* -------------------------------- */

export const stagger = (delay = 0.1) => ({
  hidden: {},
  show: {
    transition: {
      staggerChildren: delay
    }
  }
})


/* -------------------------------- */
/* Premium hover micro interactions */
/* -------------------------------- */

export const micro = {
  hover: {
    y: -3,
    scale: 1.02,
    transition: {
      duration: 0.2
    }
  },
  tap: {
    scale: 0.97
  }
}


/* -------------------------------- */
/* Card hover (for features)        */
/* -------------------------------- */

export const cardHover = {
  rest: {
    scale: 1,
    y: 0
  },
  hover: {
    y: -6,
    scale: 1.02,
    transition: {
      duration: 0.25,
      ease
    }
  }
}